// import Vue from "vue";
import { createApp } from "vue";
// v4 delete
// import {
//   ValidationProvider, ValidationObserver, extend,
// } from 'vee-validate';
// import { required, max } from 'vee-validate/dist/rules'; // 使用するバリデーションルール
import { defineRule, configure } from "vee-validate";
import { required, max } from "@vee-validate/rules";

// for event logging
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

// add plugin for global
import MyApplicationPlugin from "@/module/plugin/application";

import App from "./App.vue";
import "./assets/css/main.css";

// カスタムメッセージの設定
configure({
  generateMessage: (context) => {
    const { field, rule } = context;
    const messages = {
      required: `${field}を入力してください`,
      max: `${field}は${rule.params[0]}文字以内で入力してください`,
      mail_format: "有効なメールアドレスではありません",
    };

    return messages[context.rule.name] || "バリデーションエラー";
  },
});

defineRule("required", required);
defineRule("max", max);
defineRule("mail_format", (value) => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true;
  }
  // Check if email
  if (
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
      value
    )
  ) {
    return false;
  }
  return true;
});

const app = createApp(App);
app.use(MyApplicationPlugin);

Sentry.init({
  app,
  // eslint-disable-next-line
  dsn: SENTRY_ENDPOINT || "https://6a582feb70e4497985cfe8d12405b86d@sentry.io/1889717",
  integrations: [
    new Integrations.Vue({
      attachProps: true,
    }),
  ],
});

// datadog廃止
global.DD_LOGS = {
  logger: {
    info: (message) => console.log(message),
  },
  init: () => {},
  addLoggerGlobalContext: () => {},
};

// eslint-disable-next-line
DD_LOGS.init({
  // eslint-disable-next-line
  clientToken: DD_DOGS_TOKNEN || "pubd4810b97d83909ccb893b00bfc6a330a",
  forwardErrorsToLogs: true,
});
// eslint-disable-next-line
DD_LOGS.addLoggerGlobalContext("AppType", "front-web");

// 廃止
// Vue.config.productionTip = false;

// new Vue({
//   render: (h) => h(App),
// }).$mount("#app");
app.mount("#app");
